import EventEmitter from 'events';

export enum EventName {
  addMetadata = 'addMetadata',
  flowId = 'flowId',
}

export type EventCallback<T> = (eventValue: T) => void;

export default class EventHandler {
  private watcher = new EventEmitter();

  emitEvent<T>(event: EventName, value: T): void {
    this.watcher.emit(event, value);
  }

  addEventListener<T>(name: EventName, listener: EventCallback<T>): void {
    this.watcher.addListener(name, listener);
  }
}
